abstract class HttpException {}

export class HttpFailedToFetchException extends HttpException {}

export class HttpTimeoutException extends HttpException {}

export class HttpNotEnoughTokensException extends HttpException {}

export class HttpAssistantIsWorkingException extends HttpException {}

export class HttpBadRequestError extends HttpException {
  constructor(public readonly body: string) {
    super();
  }
}
